import { defaultState } from './defaultState';
import type { FetchFailurePayload, FetchSuccessPayload, SportsSeoState } from './types';

export const reducers = {
  'cms/fetchPage': () => ({ ...defaultState }),
  fetchWidgetDataSuccess: (state: SportsSeoState, payload: FetchSuccessPayload): SportsSeoState => {
    if (payload.expectedPath && payload.expectedPath !== payload.actualPath) {
      return {
        ...state,
        redirect: { statusCode: 301, url: payload.expectedPath }
      };
    }

    return {
      ...state,
      tokens: payload.tokens,
      alternates: payload.alternates,
      hasPreloaded: true
    };
  },
  fetchWidgetDataFailure: (state: SportsSeoState, payload: FetchFailurePayload) => ({
    ...state,
    redirect: payload.redirect,
    hasPreloaded: true
  })
};
